// extracted by mini-css-extract-plugin
export default {"period":"period-jwEt"};